
import { Box, Modal } from "@mui/material";
import { CrossIcon } from "assets/icons";
import { useState } from 'react';

const ChatbotEmbed = ({ chatbotId }: { chatbotId: string }) => {
  const [chatOpen, setChatOpen] = useState(false);
  function toggleChat() {
    setChatOpen(!chatOpen);
  }

  return (
    <> <Modal className="w-full p-0" open={chatOpen} onClose={toggleChat}>
      <Box
        className={`fixed top-[58px] bottom-[58px] right-0 w-[440px]`}
      > <div className="bg-white flex px-[23px] pt-10"><CrossIcon className='ml-auto cursor-pointer' onClick={toggleChat} /></div>
        <iframe
          style={{ height: 'calc(100vh - 116px)' }}
          src={`https://www.chatbase.co/chatbot-iframe/${chatbotId}`}
          className="w-full"
          frameBorder="0"
        ></iframe>
      </Box>
    </Modal>
      <ChatIcon toggleChat={toggleChat} />
    </>
  );
};

function ChatIcon({ toggleChat }: { toggleChat: () => void }) {
  return <div className="m-13 flex gap-7 p-[8px] cursor-pointer items-center justify-center border border-[#E6E6E6] transition-all duration-500 hover:border-black rounded-[4px] hover:bg-[#F1F6FF]" onClick={toggleChat}>
    <div className="rista-new-sprite support-icon md:hidden lg:flex"></div>
    <div className="flex flex-col text-activeColor">
      <div className="leading-none h-auto">
      <div className="text-[9px]">Rista</div></div>
      <div className="flex h-auto leading-none">
        <div className="text-[12px] font-medium">Support</div>
      </div>
    </div>
  </div>
}

export default ChatbotEmbed;